import * as React from 'react';
import { AccountLink } from '@/lib/navigation/links/AccountLink';
import Confetti from 'react-confetti';
import purchaseSuccess from '../../../../assets/images/static_pages/purchase_success.svg';

export const CheckoutSuccess = () => (
  <div className="avo-ui-3 checkout-success">
    <img style={{ height: '200px' }} src={purchaseSuccess} alt="purchaseSuccess" />
    <p className="fsz-24 bold-900 mt-10">
      Welcome to Avochato!
    </p>
    <AccountLink path="tickets">
      <span className="button bright-green mt-20">Start Texting</span>
    </AccountLink>
    <Confetti
      width={window.innerWidth}
      height={window.innerHeight}
    />
  </div>
);
